import React from "react";
import Layout from "../utils/layout";
import Contact from "../components/scenes/Contact/Contact";

export default () => (
  <Layout>
    <Contact />
  </Layout>
);
